const Events = {
	BREAKPOINT_CHANGE: 'onBreakpointChange',
};

export default Events;
